type Props = {};

export const OrderPopups = (props: Props) => {
  return (
    <div className="mx-auto max-w-6xl">
      <h1 className="text-4xl mb-8">Oderpopups</h1>
      <h2 className="text-2xl mb-8">Med tillgänliga produkter</h2>
      {/* 1: Results */}
      <div className="shadow-2xl bg-white p-10 rounded-lg flex flex-col gap-8">
        {/* Header */}
        <div className="flex flex-row justify-between items-center bg-blue-800 text-white py-2 px-8 rounded">
          <div className="flex flex-row gap-8  items-center">
            <div className="hidden sm:block">Ikon</div>
            <div>
              <div>Adress</div>
              <div>Ej ansluten</div>
            </div>
          </div>
          <div>Ny sökning</div>
        </div>
        {/* End Header */}

        {/* Products */}
        <div>
          <h3 className="text-2xl mb-4">Här är vad vi kan hjälpa dig med</h3>
          <div
            className="p-16 text-center text-white rounded"
            style={{
              position: "relative",
              backgroundImage:
                "url('https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1742&q=80')",
              backgroundSize: "cover",
              backgroundPosition: "50% 75%",
            }}
          >
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-[rgb(0,0,0,0.5)] -z-2 rounded"></div>
            <div className="z-10">
              <div className="text-2xl mb-4 drop-shadow-md">
                Se vad vi kan erbjuda på adressen och gör en beställning direkt!
              </div>
              <button className="bg-yellow-600 text-gray-900 py-2 px-8 rounded-full drop-shadow-md">
                Visa tillgängligt utbud
              </button>
            </div>
          </div>
        </div>
        {/* End Products */}
        {/* Additional info */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 items-center">
          {/* <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer p-4">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              Relaterade projekt
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Adressen ingår i ett pågående projekt
              </h4>
              <div className="text-xs">
                Har du redan beställt och vill läsa mer om vad som händer i
                projeketet. Här har vi samlat allt du behöver veta på ett och
                samma ställe.
              </div>
            </div>
          </div> */}
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer p-4">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              nyss blivit ansluten?
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Kom igång med dina tjänster
              </h4>
              <div className="text-xs">
                Tjänsteleverantörerna i stadsnätet erbjuder tjänster inom
                internet, TV och telefoni. Här kan du läsa mer om vilka som
                finns och hur du kommer igång med dina tjänster.
              </div>
            </div>
          </div>
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer p-4">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              Support/felanmälan
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Upplever du problem med din uppkoppling?
              </h4>
              <div className="text-xs">
                Här guidar vi dig i din fels¨økning och skulle du fortfarande
                uppleva problem kontakta din tjänsteleverantör.
              </div>
            </div>
          </div>
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer p-4">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              övriga frågor
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Undarar du över något annat?
              </h4>
              <div className="text-xs">
                Här finns våra vanliga frågor och svar, samt hur du kommer i
                kontakt med oss.
              </div>
            </div>
          </div>
        </div>
        {/* End Additional info */}
      </div>
      {/* End 1: Results */}
      <h2 className="text-2xl mb-8 mt-10">Med tillgänliga produkter</h2>
      {/* 1: Results */}
      <div className="shadow-2xl bg-white p-10 rounded-lg flex flex-col gap-8">
        {/* Header */}
        <div className="flex flex-row justify-between items-center bg-blue-800 text-white py-2 px-8 rounded">
          <div className="flex flex-row gap-8  items-center">
            <div className="hidden sm:block">Ikon</div>
            <div>
              <div>Adress</div>
              <div>Ej ansluten</div>
            </div>
          </div>
          <div>Ny sökning</div>
        </div>
        {/* End Header */}

        {/* Products */}
        <div>
          <h3 className="text-2xl mb-4">Här är vad vi kan hjälpa dig med</h3>
          <div
            className="p-16 text-center text-white rounded"
            style={{
              position: "relative",
              backgroundImage:
                "url('https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1742&q=80')",
              backgroundSize: "cover",
              backgroundPosition: "50% 75%",
            }}
          >
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-[rgb(0,0,0,0.5)] -z-2 rounded"></div>
            <div className="z-10">
              <div className="text-2xl mb-4 drop-shadow-md">
                Se vad vi kan erbjuda på adressen och gör en beställning direkt!
              </div>
              <button className="bg-yellow-600 text-gray-900 py-2 px-8 rounded-full drop-shadow-md">
                Visa tillgängligt utbud
              </button>
            </div>
          </div>
        </div>
        {/* End Products */}
        {/* Additional info */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 items-center">
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer p-4">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              Relaterade projekt
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Adressen ingår i ett pågående projekt
              </h4>
              <div className="text-xs">
                Har du redan beställt och vill läsa mer om vad som händer i
                projeketet. Här har vi samlat allt du behöver veta på ett och
                samma ställe.
              </div>
            </div>
          </div>
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer p-4">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              nyss blivit ansluten?
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Kom igång med dina tjänster
              </h4>
              <div className="text-xs">
                Tjänsteleverantörerna i stadsnätet erbjuder tjänster inom
                internet, TV och telefoni. Här kan du läsa mer om vilka som
                finns och hur du kommer igång med dina tjänster.
              </div>
            </div>
          </div>
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer p-4">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              Support/felanmälan
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Upplever du problem med din uppkoppling?
              </h4>
              <div className="text-xs">
                Här guidar vi dig i din fels¨økning och skulle du fortfarande
                uppleva problem kontakta din tjänsteleverantör.
              </div>
            </div>
          </div>
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer p-4">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              övriga frågor
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Undarar du över något annat?
              </h4>
              <div className="text-xs">
                Här finns våra vanliga frågor och svar, samt hur du kommer i
                kontakt med oss.
              </div>
            </div>
          </div>
        </div>
        {/* End Additional info */}
      </div>
      <h2 className="text-2xl mb-8 mt-10">Utan tillgänliga produkter</h2>
      {/* 1: Results */}
      <div className="shadow-2xl bg-white p-10 rounded-lg flex flex-col gap-8">
        {/* Header */}
        <div className="flex flex-row justify-between items-center bg-blue-800 text-white py-2 px-8 rounded">
          <div className="flex flex-row gap-8  items-center">
            <div className="hidden sm:block">Ikon</div>
            <div>
              <div>Adress</div>
              <div>Ej ansluten</div>
            </div>
          </div>
          <div>Ny sökning</div>
        </div>
        {/* End Header */}

        {/* Products */}
        <div>
          <h3 className="text-2xl mb-4">Här är vad vi kan hjälpa dig med</h3>
          <div
            className="p-16 text-center text-white rounded"
            style={{
              position: "relative",
              backgroundImage:
                "url('https://images.unsplash.com/photo-1579914982709-49bafeafb599?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80')",
              backgroundSize: "cover",
              backgroundPosition: "50% 45%",
            }}
          >
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-[rgb(0,0,0,0.5)] -z-2 rounded"></div>
            <div className="z-10">
              <div className="text-2xl mb-4 drop-shadow-md">
                Just nu finns inga beställningsbara tjänster på vald adress.
              </div>
              <div className=" drop-shadow-md">
                Har du sökt på en lägenhet ber vi dig att kontakta din hyresvärd
                för att få information om vilken lösning som erbjuds på
                adressen.
              </div>
            </div>
          </div>
        </div>
        {/* End Products */}
        {/* Additional info */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-8 items-center">
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              Relaterade projekt
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Adressen ingår i ett pågående projekt
              </h4>
              <div className="text-xs">
                Har du redan beställt och vill läsa mer om vad som händer i
                projeketet. Här har vi samlat allt du behöver veta på ett och
                samma ställe.
              </div>
            </div>
          </div>
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              Tjänster i stadsnätet
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Kom igång med dina tjänster
              </h4>
              <div className="text-xs">
                Tjänsteleverantörerna i stadsnätet erbjuder tjänster inom
                internet, TV och telefoni. Här kan du läsa mer om vilka som
                finns och hur du kommer igång med dina tjänster.
              </div>
            </div>
          </div>
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              support/felanmälan
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Upplever du problem med din uppkoppling?
              </h4>
              <div className="text-xs">
                Här guidar vi dig i din fels¨økning och skulle du fortfarande
                uppleva problem kontakta din tjänsteleverantör.
              </div>
            </div>
          </div>
          <div className="flex-1 overflow-y-scroll max-h-36 hover:scale-105 cursor-pointer">
            <h5 className="text-xs uppercase mb-1 text-gray-500">
              övriga frågor
            </h5>
            <div>
              <h4 className="text-sm font-medium mb-2 whitespace-pre-wrap break-words">
                Undarar du över något annat?
              </h4>
              <div className="text-xs">
                Här finns våra vanliga frågor och svar, samt hur du kommer i
                kontakt med oss.
              </div>
            </div>
          </div>
        </div>
        {/* End Additional info */}
      </div>
      {/* End 1: Results */}
    </div>
  );
};
